import { h } from 'preact';

const TYPE_LABELS = {
  'epx:StartEvent': 'Start Event',
  'epx:EndEvent': 'End Event',
  'epx:UserTask': 'User Task',
  'epx:ServiceTask': 'Service Task',
  'epx:ScriptTask': 'Script Task',
  'epx:ManualTask': 'Manual Task',
  'epx:Task': 'Task',
  'epx:BusinessRuleTask': 'Business Rule Task',
  'epx:SubProcess': 'Sub-Process',
  'epx:Transaction': 'Transaction',
  'epx:CallActivity': 'Call Activity',
  'epx:ExclusiveGateway': 'Exclusive Gateway',
  'epx:ParallelGateway': 'Parallel Gateway',
  'epx:InclusiveGateway': 'Inclusive Gateway',
  'epx:ComplexGateway': 'Complex Gateway',
  'epx:EventBasedGateway': 'Event-Based Gateway',
  'epx:SequenceFlow': 'Sequence Flow',
  'epx:BoundaryEvent': 'Boundary Event',
  'epx:IntermediateCatchEvent': 'Intermediate Catch Event',
  'epx:IntermediateThrowEvent': 'Intermediate Throw Event',
  'epx:Participant': 'Participant',
  'epx:Lane': 'Lane',
  'epx:DataObjectReference': 'Data Object',
  'epx:DataStoreReference': 'Data Store',
  'epx:TextAnnotation': 'Text Annotation',
  'epx:MessageFlow': 'Message Flow',
};

export function PanelHeader({ element, i18n }) {
  if (!element) return null;

  const typeName = element.type || '';
  // Strip namespace prefix for data attribute (e.g. "epx:StartEvent" → "StartEvent")
  const typeKey = typeName.includes(':') ? typeName.split(':')[1] : typeName;
  const typeLabel = (i18n && i18n[typeName]) || TYPE_LABELS[typeName] || typeKey;
  const elementName = (element.properties && element.properties.name) || element.text || '';

  return (
    <div class="epx-panel-header" data-element-type={typeKey}>
      <div class="epx-panel-header-type">
        <span class="epx-panel-type-dot" />
        {typeLabel}
      </div>
      {elementName
        ? <div class="epx-panel-header-name" title={elementName}>{elementName}</div>
        : <div class="epx-panel-header-name epx-panel-header-name--empty">Unnamed</div>
      }
    </div>
  );
}
